import { Monitor } from "lucide-react";
import BackgroundOrbs from "./BackgroundOrbs";

const MobileNotSupported = () => (
  <div
    className="min-h-[100dvh] bg-md-navy relative overflow-hidden flex flex-col items-center justify-center text-center px-6 py-10"
    data-testid="mobile-not-supported"
  >
    <BackgroundOrbs />
    <div className="relative z-10 max-w-md">
      <div className="text-md-cyan mb-8 flex justify-center">
        <Monitor size={80} strokeWidth={1.5} aria-hidden />
      </div>
      <p className="text-lg sm:text-xl font-semibold text-amber-200/95 mb-4">Oups…</p>
      <h1 className="text-2xl sm:text-3xl font-bold text-white leading-snug">
        Il n&apos;est pas possible de consulter ce site sur un appareil mobile.
      </h1>
      <p className="mt-5 text-base sm:text-lg text-white/70 leading-relaxed">
        Il a été conçu pour être consulté sur un ordinateur, avec un grand écran.
      </p>
    </div>
  </div>
);

export default MobileNotSupported;
